import blogApi from "../../api/blogs";

const state = {
  all: []
};

const getters = {};

const actions = {
  getAllBlogs({ commit }) {
    return blogApi.getBlogs().then(response => {
      commit("setBlogs", response.data);
      return response.data;
    });
  },
  getBlog(_ctx, id) {
    return blogApi.getBlog(id).then(response => {
      return response.data;
    });
  },
  postBlog({ commit }, blog) {
    return blogApi.postBlog(blog).then(response => {
      commit("addBlog", response.data);
      return response.data;
    });
  },
  putBlog({ commit }, { id, blog }) {
    return blogApi.putBlog(id, blog).then(response => {
      commit("updateBlog", response.data);
      return response.data;
    });
  },
  updateBlogStatus({ commit }, { id, isActive }) {
    return blogApi.updateBlogStatus(id, isActive).then(response => {
      commit("updateBlog", response.data);
      return response.data;
    });
  },
  deleteBlog({ commit }, id) {
    return blogApi.deleteBlog(id).then(() => {
      commit("removeBlog", id);
    });
  }
};

const mutations = {
  setBlogs(state, blogs) {
    state.all = blogs;
  },
  addBlog(state, blog) {
    state.all.unshift(blog);
  },
  updateBlog(state, updatedBlog) {
    const index = state.all.findIndex(b => b.id === updatedBlog.id);
    if (index !== -1) {
      state.all.splice(index, 1, updatedBlog);
    }
  },
  removeBlog(state, id) {
    state.all = state.all.filter(b => b.id !== id);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
